<script lang="ts">
  import {
    toImageSrcAttributes,
    toLazyloadSrcsetUrlBuilders,
    toSrcsetUrlBuilders,
    useSanityImageLazyload
  } from '$lib/sanity/image';
  import type { Image } from '$lib/sanity/schemas';
  import { pipe } from '$lib/utils/pipe';
  import type { CustomBlockComponentProps } from '@portabletext/svelte';
  import { type SanityContext, key } from '$lib/context/sanity';
  import { getContext } from 'svelte';

  export let portableText: CustomBlockComponentProps<Image>;
  let image: Image;

  if (portableText.value) {
    image = portableText.value;
  }
  const { urlBuilder } = getContext<SanityContext>(key);

  $: imageSrcAttrs =
    image?.image?.asset &&
    pipe(
      image.image?.asset,
      toSrcsetUrlBuilders(urlBuilder),
      toLazyloadSrcsetUrlBuilders($isInView),
      toImageSrcAttributes()
    );

  const { isInView, lazyload } = useSanityImageLazyload();
</script>

{#if imageSrcAttrs}
  <img
    use:lazyload
    class="lazy"
    srcset={imageSrcAttrs.srcset}
    src={imageSrcAttrs.src}
    sizes="100vw"
    alt={image?.image?.asset.altText}
  />
{/if}
